import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: number;
  email: string;
  username?: string;
  groups: string[];
  is_superuser: boolean;
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  setTokens: (access: string, refresh: string) => void;
  setUser: (user: User) => void;
  logout: () => void;
  hasGroup: (group: string) => boolean;
  hasAnyGroup: (groups: string[]) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setTokens: (access, refresh) => set({ accessToken: access, refreshToken: refresh }),
      setUser: (user) => set({ user }),
      logout: () => set({ accessToken: null, refreshToken: null, user: null }),
      hasGroup: (group) => {
        const u = get().user;
        if (!u) return false;
        if (u.is_superuser) return true;
        return u.groups.includes(group);
      },
      hasAnyGroup: (groups) => {
        const u = get().user;
        if (!u) return false;
        if (u.is_superuser) return true;
        return groups.some((g) => u.groups.includes(g));
      },
    }),
    { name: 'mandarin-admin-auth' },
  ),
);
